import React from 'react';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useField } from 'formik';

export const EditChecked = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <FormGroup row>
      <FormControlLabel
        control={
          <Checkbox
            color="primary"
            {...field}
            {...props}
          />
        }
        label={label}
      />
    </FormGroup>
  );
};
